import { APIResponse, APIResponseDtoImpl } from '../apiresponse';
import { FaqDto } from '../../dto/faq/faqdto';

export interface FaqResponse extends APIResponse
{
    getFaqDtos(): FaqDto[];
}

export class FaqResponseDtoImpl extends APIResponseDtoImpl implements FaqResponse
{
    private faqDtos : FaqDto[];

    getFaqDtos(): FaqDto[]
    {
        return this.faqDtos;
    }
    setFaqDtos(faqDtos: FaqDto[])
    {
        this.faqDtos = faqDtos;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/faq/faqresponse.tsx